import React from 'react';
import { Card, Col, Row, Skeleton, Statistic, theme } from 'antd';

type Props = {
  loading?: boolean;
  reviewsLoading?: boolean;
  questionsLoading?: boolean;
  stockAvailable: number | null;
  mpLinked: number;
  mpTotal: number;
  reviewsNew: number;
  questionsNew: number;
  onGo?: (tab: string) => void;
};

const cardStyle: React.CSSProperties = {
  height: 88,
  cursor: 'pointer',
  borderRadius: 8,
};

const bodyPad = { padding: '12px 16px' };

const StatSkeleton = () => (
  <div style={{ paddingTop: 4 }}>
    <Skeleton.Input active size="small" style={{ width: 72, height: 14 }} />
    <div style={{ marginTop: 10 }}>
      <Skeleton.Input active size="small" style={{ width: 56, height: 22 }} />
    </div>
  </div>
);

export const ProductSummary = ({
  loading,
  reviewsLoading,
  questionsLoading,
  stockAvailable,
  mpLinked,
  mpTotal,
  reviewsNew,
  questionsNew,
  onGo,
}: Props) => {
  const { token } = theme.useToken();
  const mpWarn = !loading && mpTotal > 0 && mpLinked === 0;

  return (
    <Row gutter={[12, 12]} style={{ marginBottom: 20 }}>
      <Col xs={12} md={6}>
        <Card
          size="small"
          style={cardStyle}
          bodyStyle={bodyPad}
          onClick={() => onGo?.('stocks')}
        >
          {loading ? (
            <StatSkeleton />
          ) : (
            <Statistic
              title="Доступно"
              value={stockAvailable == null ? '—' : stockAvailable}
              suffix={stockAvailable == null ? undefined : 'шт.'}
              valueStyle={{ fontSize: 22 }}
            />
          )}
        </Card>
      </Col>
      <Col xs={12} md={6}>
        <Card
          size="small"
          style={{
            ...cardStyle,
            borderColor: mpWarn ? token.colorWarning : undefined,
          }}
          bodyStyle={bodyPad}
          onClick={() => onGo?.('marketplaces')}
        >
          {loading ? (
            <StatSkeleton />
          ) : (
            <Statistic
              title="Связи с МП"
              value={`${mpLinked} из ${mpTotal || '—'}`}
              valueStyle={{
                fontSize: 22,
                color: mpWarn ? token.colorWarning : undefined,
              }}
            />
          )}
        </Card>
      </Col>
      <Col xs={12} md={6}>
        <Card
          size="small"
          style={{
            ...cardStyle,
            borderColor:
              !reviewsLoading && reviewsNew > 0 ? token.colorWarning : undefined,
          }}
          bodyStyle={bodyPad}
          onClick={() => onGo?.('reviews')}
        >
          {reviewsLoading ? (
            <StatSkeleton />
          ) : (
            <Statistic
              title="Необработанные отзывы"
              value={reviewsNew}
              valueStyle={{
                fontSize: 22,
                color: reviewsNew > 0 ? token.colorWarning : undefined,
              }}
            />
          )}
        </Card>
      </Col>
      <Col xs={12} md={6}>
        <Card
          size="small"
          style={{
            ...cardStyle,
            borderColor:
              !questionsLoading && questionsNew > 0
                ? token.colorWarning
                : undefined,
          }}
          bodyStyle={bodyPad}
          onClick={() => onGo?.('questions')}
        >
          {questionsLoading ? (
            <StatSkeleton />
          ) : (
            <Statistic
              title="Новые вопросы"
              value={questionsNew}
              valueStyle={{
                fontSize: 22,
                color: questionsNew > 0 ? token.colorWarning : undefined,
              }}
            />
          )}
        </Card>
      </Col>
    </Row>
  );
};
